export default __webpack_public_path__ + "static/media/Pagina_no_encontrada.d6900daf.svg";